// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RedditOutlinedSvg from "@ant-design/icons-svg/es/asn/RedditOutlined";
import AntdIcon from '../components/AntdIcon';

var RedditOutlined = function RedditOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RedditOutlinedSvg
  }));
};

RedditOutlined.displayName = 'RedditOutlined';
export default React.forwardRef(RedditOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/RedditOutlined.js
// module id = 1691
// module chunks = 0